// @flow

import React, { type ElementProps } from "react";
import type { ObjectFieldTemplateProps } from "@rjsf/utils";

type Props = ObjectFieldTemplateProps;

const ObjectTemplate = (props: Props) => {
  return (
    <div name="object-template">
      {props.properties.map((element, index) => (
        <div className="property-wrapper" key={index}>
          {element.content}
        </div>
      ))}
    </div>
  );
};

export default ObjectTemplate;
